export const languageMap = [
  {
    backendKey: 'reader_profile_description_languages_german',
    mappedKey: 'Deutsch',
  },
  {
    backendKey: 'reader_profile_description_languages_english',
    mappedKey: 'Englisch',
  },
  {
    backendKey: 'reader_profile_description_languages_spanish',
    mappedKey: 'Spanisch',
  },
  {
    backendKey: 'reader_profile_description_languages_portuguese',
    mappedKey: 'Portugiesisch',
  },
  {
    backendKey: 'reader_profile_description_languages_polish',
    mappedKey: 'Polnisch',
  },
];

export const socialMap = [
  {
    backendKey: 'reader_profile_description_socials_facebook',
    mappedKey: 'Facebook',
  },
  {
    backendKey: 'reader_profile_description_socials_instagram',
    mappedKey: 'Instagram',
  },
  {
    backendKey: 'reader_profile_description_socials_twitter',
    mappedKey: 'Twitter',
  },
  {
    backendKey: 'reader_profile_description_socials_youtube',
    mappedKey: 'Youtube',
  },
  {
    backendKey: 'reader_profile_description_socials_linkedin',
    mappedKey: 'LinkedIn',
  },
];

export const typeOfReadingMap = [
  {
    backendKey: 'reader_offers_type_standard',
    mappedKey: 'Human Design Reading',
  },
  {
    backendKey: 'reader_offers_type_business',
    mappedKey: 'Business Reading',
  },
  {
    backendKey: 'reader_offers_type_career',
    mappedKey: 'Karriere Reading',
  },
  {
    backendKey: 'reader_offers_type_family',
    mappedKey: 'Familien Reading',
  },
  {
    backendKey: 'reader_offers_type_children',
    mappedKey: 'Kinder Reading',
  },
  {
    backendKey: 'reader_offers_type_partner',
    mappedKey: 'Partner Reading',
  },
  {
    backendKey: 'reader_offers_type_transit',
    mappedKey: 'Transit Report',
  },
];

export const translationMap = [
  {
    backendKey: 'german',
    mappedKey: 'Deutsch',
  },
  {
    backendKey: 'english',
    mappedKey: 'Englisch',
  },
  {
    backendKey: 'spanish',
    mappedKey: 'Spanisch',
  },
  {
    backendKey: 'polish',
    mappedKey: 'Polnisch',
  },
  {
    backendKey: 'portuguese',
    mappedKey: 'Portugiesisch',
  },
  {
    backendKey: 'family',
    mappedKey: 'Familie & Kinder',
  },
  {
    backendKey: 'love',
    mappedKey: 'Liebe & Partnerschaft',
  },
  {
    backendKey: 'business',
    mappedKey: 'Business Readings',
  },
  {
    backendKey: 'career',
    mappedKey: 'Karriere',
  },
  {
    backendKey: 'private',
    mappedKey: 'Private Readings',
  },
  {
    backendKey: 'digital',
    mappedKey: 'Digitalisierung',
  },
  {
    backendKey: 'coaching',
    mappedKey: 'Coaching',
  },
  {
    backendKey: 'mediation',
    mappedKey: 'Mediation',
  },
];
